export enum UserRoleType {
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_SPRAVCE = "ROLE_SPRAVCE",
    ROLE_OPERATOR = "ROLE_OPERATOR",
}